import axios from "axios";
//chrome.exe --user-data-dir="C:/Chrome dev session" --disable-web-security
const apiClient = axios.create({
  baseURL: "https://trafficdistillery.com",
  withCredentials: false,
  headers: {
    Accept: "application/json"
  }
});

export default {
  data() {
    return {
      postBody: "",
      errors: []
    };
  },
  //apiLogin(formdata) {
  //    return apiClient.post("login?_format=json", JSON.stringify(formdata));
  //},
  apiPost(formdata) {
    return apiClient.post("tracking/apipost", JSON.stringify(formdata));
  },
  apiGet(formdata) {
    return apiClient.post("tracking/apiget", JSON.stringify(formdata));
  },
  getProjects() {
    var ret = apiClient.get("/tracking/projects_view"); //Drupal Views
    return ret;
  }
};
